const actions = {
  LOGIN_BEGIN: 'LOGIN_BEGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERR: 'LOGIN_ERR',

  LOGOUT_BEGIN: 'LOGOUT_BEGIN',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_ERR: 'LOGOUT_ERR',

  loginBegin: () => {
    return {
      type: actions.LOGIN_BEGIN,
    };
  },

  loginSuccess: (data: any) => {
    return {
      type: actions.LOGIN_SUCCESS,
      data,
    };
  },

  loginErr: (err: any) => {
    const serializableErr = err instanceof Error 
      ? { message: err.message, name: err.name, code: (err as any).code } 
      : (typeof err === 'object' && err !== null ? { ...err } : err);
    return {
      type: actions.LOGIN_ERR,
      err: serializableErr,
    };
  },

  logoutBegin: () => {
    return {
      type: actions.LOGOUT_BEGIN,
    };
  },

  logoutSuccess: (data: any) => {
    return {
      type: actions.LOGOUT_SUCCESS,
      data,
    };
  },

  logoutErr: (err: any) => {
    const serializableErr = err instanceof Error 
      ? { message: err.message, name: err.name, code: (err as any).code } 
      : (typeof err === 'object' && err !== null ? { ...err } : err);
    return {
      type: actions.LOGOUT_ERR,
      err: serializableErr,
    };
  },
};

export default actions;
